(() => {
  function setup(bar) {
    if (bar.dataset.ready) return;
    bar.dataset.ready = 'true';
    const list = document.getElementById(bar.dataset.finishFilter);
    if (!list) return;
    const chips = [...bar.querySelectorAll('.finish-filter__chip')];
    const status = bar.querySelector('[data-finish-status]');
    chips.forEach((chip) => {
      chip.addEventListener('click', () => {
        const words = chip.dataset.match.split(',').map((w) => w.trim()).filter(Boolean);
        let shown = 0;
        list.querySelectorAll(':scope > li[data-finish]').forEach((item) => {
          const text = item.dataset.finish;
          const match = words.length === 0 || words.some((w) => text.includes(w));
          item.hidden = !match;
          if (match) shown++;
        });
        chips.forEach((c) => c.setAttribute('aria-pressed', String(c === chip)));
        if (status) status.textContent = chip.textContent.trim() + ': ' + shown;
      });
    });
  }
  const init = (root) => root.querySelectorAll('[data-finish-filter]').forEach(setup);
  init(document);
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
